var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlsSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.343,
    height: 53.343,
    viewBox: "0 0 53.343 53.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47699",
    transform: "translate(-6.334 -6.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5362",
    cx: 23.337,
    cy: 23.337,
    r: 23.337,
    transform: "translate(9.667 9.667)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45935",
    d: "M2241.714 1859.443a26 26 0 1 1-26 26 26.034 26.034 0 0 1 26-26m0-.667a26.671 26.671 0 1 0 26.671 26.671 26.7 26.7 0 0 0-26.671-26.671z",
    transform: "translate(-2208.71 -1852.443)",
    style: {
      fill: "#dfdfdf"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51180"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 23347",
    transform: "translate(17.498 14.906)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h18.848v21.361H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 78340",
    d: "M21.023 11.85H0v23.4h21.023zM8.973 32.016H3V14.931h5.987zM13.6 14.949a4.261 4.261 0 0 1 4.334 4.4 4.066 4.066 0 0 1-4.348 4.138h-2.33v-8.534zm-2.344 17.108v-8.463l8.2 8.463z",
    transform: "translate(16.161 2.037)",
    style: {
      fill: "#151aae"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlsSocial);
export default __webpack_public_path__ + "static/media/mls-social.963684b7c924077bb03295a9cb170162.svg";
export { ForwardRef as ReactComponent };